import { baseUrl } from '@/shared/constants'
import axios, { AxiosResponse } from 'axios'
import { AuthParamsType, UpdateUserSettingsParamsType } from './types/types.ts'
import { FriendsListResponse } from './types/types.ts'
import { GetProfileResponseType } from './types/dto.ts'

export const authReq = async (params: AuthParamsType) => {
  const response = await axios.post(`${baseUrl}/user/`, params, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export const refreshToken = async (token: string) => {
  const response = await axios.post(`${baseUrl}/user/token`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const postSubscribeToPlus = async (token: string, subscription_id: number) => {
  const response = await axios.post(
    `${baseUrl}/user/plus/purchase`,
    {
      subscription_id: subscription_id,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}

export const postSubscribeToPlatinum = async (token: string, subscription_id: number) => {
  const response = await axios.post(
    `${baseUrl}/user/platinum/purchase`,
    {
      subscription_id: subscription_id,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}

export const postPurchaseDiscount = async (token: string, subscription_id: number) => {
  const response = await axios.post(
    `${baseUrl}/user/platinum/purchase_discount`,
    {
      subscription_id: subscription_id,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}

export const getSubscriptionPrices = async (token: string) => {
  const response = await axios.get(`${baseUrl}/user/plus/prices`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const insertUserSettings = async (props: UpdateUserSettingsParamsType) => {
  const { token, data } = props
  const response = await axios.post(`${baseUrl}/user/setting`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getAllFriendsList = async (token: string, page: number, size: number): Promise<FriendsListResponse> => {
  const response = await axios.get(`${baseUrl}/user/all-friends?page=${page}&size=${size}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data
}

export const postAddFriend = async (token: string, friend_tid: number) => {
  const response = await axios.post(
    `${baseUrl}/user/add-friend/`,
    {
      friend_tid: friend_tid,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}

export const deleteRemoveFriend = async (token: string, friend_tid: number) => {
  const response = await axios.delete(`${baseUrl}/user/delete-friend/`, {
    data: {
      friend_tid: friend_tid,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getFriendStatus = async (token: string, friend_tid: number): Promise<boolean> => {
  const response = await axios.get(`${baseUrl}/user/is-friend?friend_tid=${friend_tid}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}
export const getUserInfo = async (token: string, tid: number) => {
  const response = await axios.get(`${baseUrl}/user/info?user_tid=${tid}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getUserProfile = async (token: string) => {
  const response: AxiosResponse<GetProfileResponseType> = await axios.get(`${baseUrl}/user/profile`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getFriendsReward = async (token: string) => {
  const response = await axios.get(`${baseUrl}/user/claim-referrals`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}
